import styled, { css } from 'styled-components';
export const ImageContainer = styled.div `
  position: relative;
  ${({ height }) => height &&
    css `
      height: ${height};
    `};

  ${({ width }) => width &&
    css `
      width: ${width};
    `};
`;
export const Image = styled.img `
  object-fit: cover;
  ${({ borderRadius }) => css `
      border-radius: ${borderRadius};
    `}

  ${({ height }) => height &&
    css `
      height: ${height};
    `};

  ${({ width }) => width &&
    css `
      width: ${width};
    `};
`;
//# sourceMappingURL=BKJImage.styled.js.map